require('stylesheets/news');